import moment from 'moment'

export const getDateUTC = (dateMoment) => {  // alternative could be to use moment-timezone in future
  if (dateMoment) {
    let date = dateMoment

    let utcOffset = date.utcOffset()  // get offset in minutes
    if (utcOffset !== 0) {  // if not set to UTC
      // add offset, setting dob time equal to UTC
      date.add(utcOffset, 'm')
      // sets flag to use UTC instead to display time (not changing timezone)
      date.utc()
    }

    return date
  } else {
    return null
  }
}

// function below to be used as sort function with Array.sort
export const sortDates = (a, b, descending) => {
  let momentA = moment(a)
  let momentB = moment(b)

  if (momentA.isBefore(momentB)) {
    return descending ? 1 : -1
  }

  if (momentB.isBefore(momentA)) {
    return descending ? -1 : 1
  }

  return 0
}

export const hasDateChanged = (current, next) => {
  if (next === null && current !== null) {
    return true
  } else if (next === null && current === null) {
    return false
  } else if (next.isSame(current)) {
    return false
  } else {
    return true
  }
}

// start & end dates strings should match formats as detailed on https://momentjs.com/docs/#/parsing/string/
// valid frequency values: year/quarter/month/week/day (https://momentjs.com/docs/#/parsing/string/)
export const datesInRangeFrequency = (startDate, endDate, frequency, outputDateFormat) => {
  const MAX_DATES = 52

  let currentDate = moment(startDate)
  let nextDateInCycle = moment(startDate).add(1, frequency+'s')
  let hasNextCycle = currentDate.isSameOrBefore(endDate, 'day')

  let invalidInputFields = []
  if (!currentDate.isValid()) {
    invalidInputFields.push('startDate')
  }
  if (!moment(endDate).isValid()) {
    invalidInputFields.push('endDate')
  }
  if (['year', 'quarter', 'month', 'week', 'day'].indexOf(frequency) === -1) {
    invalidInputFields.push('frequency')
  }
  if (invalidInputFields.length > 0) {
    throw new Error(`Invalid input value(s): ${invalidInputFields}`)
  }

  let dates = []
  let i = 0
  do {
    dates.push(currentDate.format(outputDateFormat || 'DD/MM/YYYY'))
    i += 1
    nextDateInCycle = currentDate.add(1, frequency+'s')
    hasNextCycle = nextDateInCycle.isSameOrBefore(endDate, 'day')
    currentDate = nextDateInCycle
  } while ((currentDate.isSame(endDate, 'day') || hasNextCycle) && i < MAX_DATES)

  return dates
}

export const getNextBusinessDay = (day) => {
  let nextBusinessday = null
  let today = day || moment()

  if (today.day() === 5) { // Friday, show Monday
    // set to Monday
    nextBusinessday = today.weekday(8)
  } else if (today.day() === 6) { // Saturday, show Monday
    // set to monday
    nextBusinessday = today.weekday(8)
  } else { // other days, show next day
    nextBusinessday = today.add('days', 1)
  }

  return nextBusinessday
}



// WEBPACK FOOTER //
// ./src/utils/date/index.js